import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { debit } from '../../../../../../redux';
import { Button, Form, FormGroup, Input, } from 'reactstrap';
import Icon from '@mdi/react';
import { mdiCash } from '@mdi/js';

const CollectButton = ({ collector }) => {
    const { t }           = useTranslation();
    const dispatch        = useDispatch();

    const [isFormVisible, showForm] = useState(false);
    const [amount, setAmount]       = useState(0);

    const doDebit = () => {
        dispatch(debit(collector.id, amount));
        setAmount(0);
    }

    return (
        <>
            <Button
                onClick={ () => { showForm(!isFormVisible) }}
                className={ `operation ${isFormVisible ? 'form-visible' : ''}` }
                color="info"
                block
            >
                <div className="icon">
                    <Icon path={ mdiCash } size={ 3 } color="#FFFFFF" />{ ' ' }
                </div>
                <div className="title">
                    { t('collectors.collect') }
                    <div className="subtitle">{ t('collectors.collect_desc') }</div>
                </div>
            </Button>

            { isFormVisible && (
            <Form className="operation-form">
                <div className="form-body">
                    <FormGroup>
                        <Input
                            type="decimal"
                            placeholder={ t('collectors.debit_amount_label_placeholder') }
                            onChange={(e) => { setAmount(e.target.value); }}
                            value={ amount }
                        />
                    </FormGroup>
                </div>
                <div className="form-footer">
                    <Button
                        color="info"
                        onClick={ doDebit }
                    >
                        <Icon path={ mdiCash } size={ 1 } color="#FFFFFF" />{ ' ' }
                        { t('collectors.collect') }
                    </Button>
                </div>
            </Form>
            )}
        </>
    );
}

export default CollectButton;
